
        <div class="custom-select" (click)="toggleSelect($event)" [ngClass]="{'opened': isOpened}">
            <span>{{placeholder}}</span> 
        </div>
        <div class="custom-options" *ngIf="isOpened">
            <div class="custom-option-row" *ngFor="let item of options" [attr.data-selected]="item.selected" (click)="selectOption(item)">
                <span [attr.data-optid]="item.id" (click)="selectOption(item)">{{item.name}}</span>
            </div>
        </div>
    